<script lang="ts" setup>
  import { route } from '../../../shared/config/routes.ts';
  import NotFoundView from './NotFoundView.vue';
</script>

<template>
  <NotFoundView @go-to-start="$router.push({ name: route.index })" />
</template>
